module.exports = __webpack_public_path__ + "static/Gallery-11-bc4dfa50e42c4b963bd8796cc52277fb.jpg";